// @flow
import styled from "styled-components";

export const Outer = styled.div`
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 900px;
    margin-top: 25px;
    background-color: #fff;

    @media only screen and (min-width: 768px) {
    }
`;

export const Blogs = styled.div`
    padding: 16px;
`;

export const Blog = styled.div`
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
export const Date = styled.div`
    display: inline-block;
    padding: 8px 0;
    width: 130px;
    padding: 4px 8px 4px 0;
`;
export const Title = styled.div`
    display: inline;
    padding: 4px 8px 4px 0;
`;



// WEBPACK FOOTER //
// ./src/journals-page-view/styled.js